import React from "react";
import "./Header.css";
import Logo from "../../assets/logo.png";
const Header = () => {
  return (
    <div className="header">
      <div className="blur"></div>
      <img src={Logo} alt="" className="logo" />
      <ul className="header-menu">
        <li>
          <a href="#hero">Home</a>
        </li>
        <li>
          <a href="#program">Program</a>
        </li>
        <li>
          <a href="#reason">Why us</a>
        </li>
        <li>
          <a href="#plan">Plans</a>
        </li>
        <li>
          <a href="#testimonial">Testimonials</a>
        </li>
      </ul>
    </div>
  );
};

export default Header;
